import React, { useState } from "react";
import { Flex, Box, Avatar, List, ListItem } from "@chakra-ui/react";
import { Link } from "react-router-dom"

import { IconStar } from "@assets/Icons";
import { like_candidate, unlike_candidate } from "@lib/datahandlers/company";

const CandidateItem = ({ data, iconType, setFavouriteCandidates, favouriteCandidates, id }) => {
  const { person, address, picture, liked } = data;
  const [favourite, setFavorite] = useState(liked ? true : false);

  const handleStar = (e, id) => {
    e.preventDefault();
    setFavorite(!favourite);
    favourite ? onUnLike(id) : onLike(id);
  };
  // like candidate
  const onLike = async (id) => {
    try {
      const result = await like_candidate({ person_id: id });
      if (result.success) return;
    } catch (err) {
      console.log("Error: ", err);
    }
  };
  // unlike candidate
  const onUnLike = async (id) => {
    try {
      const result = await unlike_candidate({ person_id: id });
      if (result.success) {
        setFavouriteCandidates(favouriteCandidates.filter(el => el.person.id !== id))
        return;
      }
    } catch (err) {
      console.log("Error: ", err);
    }
  };

  return (
    <Flex as={Link}
      to={`/company/search/person/${id}`}
      flexDir="row"
      justifyContent="space-between"
      alignItems="center"
      boxShadow="2px 2px 20px 0px #00000026"
      borderRadius="4px"
      w="385px" h="125px" p=".5rem 1rem" mb="28px"
    >
      <Avatar src={picture} name={person.first_name} w="90px" h="90px" my="auto" />

      <List fontSize="12px" w="167px">
        <ListItem fontWeight="bold" fontSize="16px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
          {`${person.first_name} ${person.last_name}`}
        </ListItem>
        <ListItem color="gray.borderBoxes">
          {person.age && `${person.age} ans`}
        </ListItem>
        <ListItem fontWeight="bold" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap"> 
          {person.fonctions.map(el => el.name).join(', ')} 
        </ListItem>
        <ListItem>
          {`Exp: ${person.experience.name && person.experience.name}`}
        </ListItem>
        <ListItem color="gray.borderBoxes" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap"> 
          {address && address} 
        </ListItem>
      </List>       

      <Flex justifyContent="space-between" flexDir="column" alignItems="flex-end" m="0" h="100%">
        <IconStar
          iconType={iconType}
          variant={favourite ? "filled" : "outline"}
          event={(e) => handleStar(e, person.id)}
        />
      </Flex>
    </Flex>
  );
};

export default CandidateItem;
